import * as Redux from 'redux';

export class PackagesPageActions {
    public static init(): (dispatch: any) => void {
        return (dispatch: any) => {
            dispatch({ type: 'Pages/Packages/Init', payload: null });
        };
    }
}
